import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { DENTAL_SPECIALTIES } from '../lib/constants';

// ==========================================================
// Component ฉลากสติ๊กเกอร์ขนาดกะทัดรัด (Consumable Compact Mini Label)
// เหมาะสำหรับขวดน้ำยาขนาดเล็ก, หลอด Composite, ขวด Bonding ฯลฯ
// Layout: 200px x 400px (Rotated 90deg เป็น 400px x 200px)
// ==========================================================
const ConsumableCompactLabel = React.forwardRef(({ data = {}, previewMode = false }, ref) => {
  const qrValue = data.qr_code || data.id || '';

  // แปลง Specialty เป็น Code ย่อ (e.g. OP, PROS, ENDO, GEN)
  const specialtyObj = DENTAL_SPECIALTIES.find(
    s => s.name === data.specialty || s.id === data.specialty || s.code === data.specialty
  );
  const specialtyCode = data.specialty_code || (specialtyObj ? specialtyObj.code : 'GEN');

  // จัดรูปแบบวันหมดอายุแบบย่อ YY-MM
  let compactExp = data.exp_date || '-';
  if (data.exp_date && data.exp_date.includes('-')) {
    const parts = data.exp_date.split('-');
    if (parts.length >= 2) {
      const yy = parts[0].length === 4 ? parts[0].slice(-2) : parts[0];
      compactExp = `${yy}-${parts[1]}`;
    }
  }

  return (
    <div
      ref={ref}
      style={{
        width: '200px',
        height: '400px',
        backgroundColor: '#ffffff',
        position: 'relative',
        overflow: 'hidden',
        border: previewMode ? '2px solid #cbd5e1' : 'none',
        boxSizing: 'border-box'
      }}
    >
      <div
        style={{
          width: '400px',
          height: '200px',
          position: 'absolute',
          top: 0,
          left: '200px',
          transformOrigin: '0 0',
          transform: 'rotate(90deg)',
          display: 'flex',
          flexDirection: 'column',
          padding: '10px 14px',
          boxSizing: 'border-box',
          fontFamily: "'Sarabun', 'Segoe UI', -apple-system, sans-serif",
          color: '#000000'
        }}
      >
        {/* แถบ Inverted Mini Badge ด้านบน */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '6px'
          }}
        >
          <div
            style={{
              backgroundColor: '#000000',
              color: '#ffffff',
              fontSize: '13px',
              fontWeight: 'bold',
              padding: '2px 8px',
              borderRadius: '4px',
              letterSpacing: '0.5px'
            }}
          >
            ■ CON: {specialtyCode} ■
          </div>
          <div style={{ fontSize: '11px', color: '#4b5563', fontWeight: '600' }}>
            {data.caretaker_name ? `ผู้ดูแล: ${data.caretaker_name}` : 'ทันตกรรม รพ.ฝาง'}
          </div>
        </div>

        {/* ส่วนเนื้อหาหลัก */}
        <div style={{ display: 'flex', flex: 1, alignItems: 'center', gap: '10px' }}>
          {/* ข้อมูลด้านซ้าย */}
          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              height: '100%',
              maxWidth: '250px',
              gap: '4px'
            }}
          >
            {/* ชื่อรายการแบบกระชับ */}
            <div
              style={{
                fontSize: '20px',
                fontWeight: '900',
                lineHeight: '1.2',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical'
              }}
              title={data.item_name}
            >
              {data.item_name || '-'}
            </div>

            {/* LOT & EXP ย่อ */}
            <div style={{ fontSize: '14px', fontWeight: 'bold', lineHeight: '1.35', marginTop: '2px' }}>
              <div>LOT: {data.lot_number || '-'}</div>
              <div>EXP: <span style={{ color: previewMode ? '#d97706' : '#000000' }}>{compactExp}</span></div>
            </div>

            {/* หน่วย & ราคา */}
            <div style={{ fontSize: '12px', color: '#1f2937', fontWeight: '600' }}>
              {data.unit_price ? `฿${Number(data.unit_price).toLocaleString()} ` : ''}
              {data.unit ? `(${data.unit})` : ''}
              {data.receipt_number ? ` • #${data.receipt_number}` : ''}
            </div>
          </div>

          {/* QR Code กะทัดรัด */}
          <div
            style={{
              width: '120px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <div
              style={{
                border: '1.5px dashed #000000',
                borderRadius: '4px',
                padding: '3px',
                backgroundColor: '#ffffff',
                display: 'inline-flex'
              }}
            >
              <QRCodeCanvas
                value={qrValue || 'CON-EMPTY'}
                size={85}
                level="M"
                style={{ width: '85px', height: '85px', display: 'block' }}
              />
            </div>
            <div
              style={{
                fontSize: '10.5px',
                marginTop: '3px',
                fontFamily: 'monospace',
                textAlign: 'center',
                fontWeight: 'bold',
                letterSpacing: '0.2px'
              }}
            >
              {qrValue || '-'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ConsumableCompactLabel;
